export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14631.aa988a53.jpg";